import React from 'react';
import Tooltip from '@aseda_library/ui/Tooltip';
import LinkOutIcon from '@as_core/icons/linkOut.icon';
import { DocumentIconLink } from '@as_core/styles/elementStyles';

interface PropsI {
  doi: string;
  inNewTab?: boolean;
}

const debug = false;
const OpenReferenceForDOI = (props: PropsI) => {
  const {doi, inNewTab=true} = props;

  const handleDownload = async () => {
    if (debug) console.log(`OpenReferenceForDOI.handleDownload | doi: ${doi}`);
    const doi_url = `https://doi.org/${doi}`;
    const link = document.createElement('a');
    link.href = doi_url;
    if (inNewTab) link.target = '_blank';
    link.click();
  }

  if (!doi) return null;

  return (
    <Tooltip
      key={`doi_link_tooltip_${doi}`}
      title={'Open DOI reference in a new tab'}
      placement={'bottom-start'}
      arrow
    >
      <DocumentIconLink
        key={`doi_${doi}`}
        onClick={() => handleDownload()}
        isActive={true}
      >
        <LinkOutIcon />
      </DocumentIconLink>
    </Tooltip>
  );
};

export default OpenReferenceForDOI;

